import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step3 } from '../../../../../shared/models/component-messages/simp_at/step3';
import { AttributionFromFNSimple } from '../../models/AttributionFromFNSimple';

@Component({
	selector: 'app-step3',
	templateUrl: './step3.component.html'
})
export class Step3Component implements OnInit {
	@Input() fnSimpleAttribution: AttributionFromFNSimple;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() uid = '';
	@Input() linkForRouter: string;

	public step3 = new Step3();

	constructor() {}

	public ngOnInit() {}

	public getUid() {
		return this.uid;
	}
}
